/* ============
 * Contract Module
 * ============
 */

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    leaseRateChangeEventPaymentIds: [],
    notChangesEventPaymentIds: [],
  },
  actions,
  mutations,
  getters,
};
